import { createNavigator } from "single-spa/react-app/router/utils/BaseNavigator";

import { ROUTES as AI_ROUTES } from "./ai-channels/constants";
import type { AiChannelsParamKeys } from "./ai-channels/routes.types";
import { ROUTES } from "./social-channels/constants";
import type { SocialChannelsParamKeys } from "./social-channels/routes.types";

export const SOCIAL_CHANNELS_ROUTES = {
    promo: ROUTES.ADS.stateName,
} as const;

export const adIntelNavigation = createNavigator<SocialChannelsParamKeys, typeof SOCIAL_CHANNELS_ROUTES>(
    SOCIAL_CHANNELS_ROUTES,
);

export const AI_CHANNELS_ROUTES = {
    ads: AI_ROUTES.ADS.stateName,
} as const;

export const aiAdIntelNavigation = createNavigator<AiChannelsParamKeys, typeof AI_CHANNELS_ROUTES>(AI_CHANNELS_ROUTES);
